module.exports = __webpack_public_path__ + "static/media/Banner Mobile-1.225b923c.png";